import { Button, Grid, makeStyles, FormControlLabel, Checkbox, Table, TableBody, TableCell, TableContainer, TableRow, TablePagination } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { conveniosValorFijoGetPracticasActivas } from '../../../../actions/contrataciones/contratacionesConvenios';
import { useEffect } from 'react';
import { ExitToAppSharp } from '@material-ui/icons';
import { agregarRelacionMedicoPractica, eliminarRelacionMedicoPractica, fetchRelacionMedicoPractica } from '../../../../actions/turnos/relacionPracticaMedico';

const useStyles = makeStyles({
  botonera: {
    padding: 25
  },
  table: {
    marginTop: 15,
    marginBottom: 20,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem',
    margin: 1
  },
});

export const ModalAgregarPracticas = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { idProfesional, idEspecialidad, idCentroMedico } = props;
  const { valorFijoPracticasActivas } = useSelector((state) => state.contratacionesConvenios);
  const { items } = useSelector((state) => state.relacionMedicoPractica);

  useEffect(() => {
    dispatch(conveniosValorFijoGetPracticasActivas(idProfesional));
    dispatch(fetchRelacionMedicoPractica(idProfesional));
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Agregar esta línea
  };


  const handleChangeCheckbox = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
        dispatch(agregarRelacionMedicoPractica(idProfesional, idEspecialidad,idCentroMedico, value))
     } else {
      dispatch(eliminarRelacionMedicoPractica(idProfesional, idEspecialidad,idCentroMedico, value))
     }
  };

  const PracticasActivas = valorFijoPracticasActivas.map((item) => ({
    id: item.codigoPractica,
    label: item.nombrePractica,
    idEspecialidad: idEspecialidad,
    
  }));


  const slicedPracticasActivas = PracticasActivas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const isPracticaSeleccionada = (practicaId) => {
    return items.some((item) => item.codNom === practicaId && item.idEspecialidad === idEspecialidad);
  };

  return (
    <>
      <TableContainer className={classes.table}>
        <Table >
          <TableBody>
            {slicedPracticasActivas.map((opcion) => (
              <TableRow key={opcion.id}>
                <TableCell>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={`${opcion.id}`}
                        checked={isPracticaSeleccionada(opcion.id)}
                        onChange={handleChangeCheckbox}
                        value={opcion.id}
                      />
                    }
                    label={`${opcion.id} - ${opcion.label}`}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        className={classes.pagination}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={PracticasActivas.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <Grid container className={classes.botonera}>
        <Grid item xs={12}>
          <Grid container spacing={1} direction="row" justify="flex-end" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<ExitToAppSharp />}
              style={{ marginLeft: "0.5rem" }}
              onClick={props.cerrarModal}
            >
              SALIR
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>               
  );
};